import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatDialogModule } from '@angular/material/dialog';
import { ComponentsModule } from '../components/components.module';
import { BottomSheetAlertComponent } from './bottom-sheet-alert.component';
import { BottomSheetGenericComponent } from './bottom-sheet-generic.component';
import { DialogAlertComponent } from './dialog-alert.component';
import { DialogGenericComponent } from './dialog-generic.component';

@NgModule({
  declarations: [
    DialogAlertComponent,
    BottomSheetAlertComponent,
    BottomSheetGenericComponent,
    DialogGenericComponent,
  ],
  imports: [CommonModule, MatBottomSheetModule, MatDialogModule, LayoutModule, ComponentsModule],
})
export class AlertsModule {}
